import RequestNewSlinger from "./RequestNewSlinger";
export default RequestNewSlinger;
